import { useFormContext } from 'react-hook-form';
import { Checkbox } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { useGetPreContractualAgreementQuery, useGetPreContractualInformationMutation, } from '@app/api/preContractualApi';
import { InlineSpinner } from '@app/components/InlineSpinner';
import { PageLoader } from '@app/components/PageLoader';
import { availableTo } from '@app/configs/dateTime';
import { DocumentTypes } from '@app/configs/loanApplication';
import { mapLithuanianToLocalTime } from '@app/utils/time';
const Agreement = ({ period, amount }) => {
    const { t } = useTranslation();
    const time = mapLithuanianToLocalTime(availableTo);
    const { data, isLoading: loadingAgreements } = useGetPreContractualAgreementQuery({
        period,
        amount,
        documentType: DocumentTypes.SpecialConditions,
    });
    const [getPreContractualInformation, { isLoading: loadingInformation }] = useGetPreContractualInformationMutation();
    const { register, formState: { errors }, } = useFormContext();
    if (loadingAgreements) {
        return <PageLoader />;
    }
    const handleOpenSpecialConditions = (event) => {
        event.preventDefault();
        getPreContractualInformation({
            period,
            amount,
            documentType: DocumentTypes.SpecialConditions,
        });
    };
    return (<div className="grid grid-cols-1 md:grid-cols-[3fr_2fr] gap-6">
            <div>
                <div className="h-[600px] overflow-y-auto">
                    <iframe className="h-full w-full" srcDoc={data === null || data === void 0 ? void 0 : data.preview} title="agreement"/>
                </div>
            </div>
            <div className="rounded-lg border border-neutral-primary-initial p-4">
                <h3 className="title-s">{t('financing.loan_application.please_review_and_agree')}</h3>
                <p className="body-m text-neutral-secondary-initial mt-2">
                    {t('financing.loan_application.agreement_notice', { time })}
                </p>
                <div className="border-t border-neutral-primary-initial mt-4 pt-4">
                    <p className="label-m mb-3">{t('financing.loan_application.please_scroll_down')}</p>
                    <Checkbox className="min-w-4 items-start" variant={errors.isSpecialConditionsAccepted ? 'critical' : 'default'} {...register('isSpecialConditionsAccepted')} label={<div className="flex gap-1 flex-wrap">
                                {`${t('financing.loan_application.checkbox_title')} `}
                                <button type="button" onClick={handleOpenSpecialConditions} className="text-action-primary-initial underline hover:no-underline">
                                    {t('financing.loan_application.special_conditions')}
                                </button>
                                <InlineSpinner isLoading={loadingInformation}/>
                            </div>}/>
                    {errors.isSpecialConditionsAccepted && (<p className="text-critical-primary-initial body-s mt-2">
                            {t('financing.loan_application.agreement_validation_error')}
                        </p>)}
                </div>
            </div>
        </div>);
};
export default Agreement;
